import { A } from '@adornis/base/env-info.js';
import { registerQuery, registerSubscription } from '@adornis/baseql/metadata/register.js';
import { getCollection } from '@adornis/baseql/server/collections.js';
import { watchQuery } from '@adornis/baseql/server/watchQuery.js';
import type { BaseQLSelectionSet, NarrowedEntity } from '@adornis/baseql/utils/queryGeneration.js';
import { map } from 'rxjs';
import { AdminInstitutionViewSetting } from '../entities/AdminInstitutionViewSetting.js';

export const getViewSettings = registerQuery({
  operationName: 'getViewSettings',
  params: [
    { name: 'userID', type: () => String },
    { name: 'institutionID', type: () => String },
  ],
  type: () => AdminInstitutionViewSetting,
  resolve:
    (userID: string, institutionID: string) =>
    async <SelSet extends BaseQLSelectionSet<AdminInstitutionViewSetting>>(
      gelFields: SelSet,
    ): Promise<NarrowedEntity<AdminInstitutionViewSetting, SelSet>> => {
      const col = await getCollection(AdminInstitutionViewSetting._class);
      const viewSettings = await col.findOne({ userID, institutionID });
      if (viewSettings) return viewSettings as any;

      // create if not exist
      const newViewSettings = new AdminInstitutionViewSetting({ _id: A.getGloballyUniqueID(), userID, institutionID });
      await newViewSettings.create();
      return newViewSettings as any;
    },
});

export const subscribeAdminInstitutionViewSetting = registerSubscription({
  operationName: 'subscribeAdminInstitutionViewSetting',
  params: [
    { name: 'userID', type: () => String },
    { name: 'institutionID', type: () => String },
  ],
  type: () => AdminInstitutionViewSetting,
  resolve: (userID: string, institutionID: string) => {
    return (qglFields: BaseQLSelectionSet<AdminInstitutionViewSetting>) => {
      return watchQuery(AdminInstitutionViewSetting._collectionName, { userID, institutionID }).pipe(
        map(viewSettings => viewSettings.at(0) as AdminInstitutionViewSetting),
      );
    };
  },
});
